import { Slide } from "react-reveal";
import ArasusCaseStudyCard from "./case-study-cards/ArasusCaseStudyCard";
import KCGCaseStudyCard from "./case-study-cards/KCGCaseStudyCard";
import HanaSafarisCaseStudyCard from "./case-study-cards/HanaSafarisCaseStudyCard";
import SdaCaseStudyCard from "./case-study-cards/SdaCaseStudyCard";
import NegashCaseStudyCard from "./case-study-cards/NegashCaseStudyCard";
import DylanCaseStudyCard from "./case-study-cards/DylanCaseStudyCard";
import AgmaCaseStudyCard from "./case-study-cards/AgmaCaseStudyCard";
import FlexipaintersCaseStudyCard from "./case-study-cards/FlexipaintersCaseStudyCard";
import K9CaseStudyCard from "./case-study-cards/K9CaseStudyCard";

/*
import agma from "../../../assets/images/case-studies/agma.jpg";
import aykonik from "../../../assets/images/case-studies/aykonik.jpg";
import aypoultry from "../../../assets/images/case-studies/aypoultry.jpg";
import bluetides from "../../../assets/images/case-studies/bluetides.jpg";
import jmstone from "../../../assets/images/case-studies/jmstone.jpg";
import taneem from "../../../assets/images/case-studies/taneem.jpg";
import gk9 from "../../../assets/images/case-studies/gk9.jpg";
import gfarm from "../../../assets/images/case-studies/gfarm.jpg";
import twin from "../../../assets/images/case-studies/twin.jpg"; 
  */

const CaseStudiesBody = () => {
  return (
    <section className="case-studies section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head center width-800 margin-auto section-spacing-50 no-padding-top">
              <p className="section-tag boldTitle">CASE STUDIES</p>
              <Slide top>
                <h2 className="section-title ntuna-text-fill">
                  Featured Case Studies
                </h2>
              </Slide>
            </div>
            <div className="section-body">
              <ul className="case-studies-container">
                <HanaSafarisCaseStudyCard />
                <FlexipaintersCaseStudyCard />
                <ArasusCaseStudyCard />
                <KCGCaseStudyCard />
                <SdaCaseStudyCard />
                <NegashCaseStudyCard />
                <K9CaseStudyCard />
                <DylanCaseStudyCard />
                <AgmaCaseStudyCard />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesBody;
